import { Pipe, PipeTransform } from '@angular/core'
import { ProfileSection, ProfileSectionNameMappings } from '../model/resume-share.model'

@Pipe({ name: 'profileSection', standalone: true })
export class ProfileSectionPipe implements PipeTransform {
  transform(value: ProfileSection) {
    return ProfileSectionNameMappings[value] || ''
  }
}
